import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-component-dashboard-item',
  templateUrl: './dashboard-item.component.html',
  styleUrls: ['./dashboard-item.component.scss'],
  standalone: false,
})
export class DashboardItemComponent {
  @Input() label: string;
  @Input() value: string;
}
